/* 2023 created for BSG by jy around 2016: 
** LOCATION:  src/views/Reports/Reports.js
**            xt this was created in the original system in 2016
**            xt it looks like it tried to use ReportSummaries early on but abandoned it to use or create reportings
**            xt I want clean readable, maintainable code
** PLEASE PUT ALL CHANGE HISTORY NOTES HERE AS WELL AS IN THE CODE LOCATION ITSELF!!!
** PLEASE USE USA TIME FORMAT  MM/DD/YYYY  OR YYYYMMDD
** 20230915: - GK made changes to keep the Reports Tab table, sticky so it stays on top when scrolling.
**             and to create scroll bars horiz, vert.
** 20241103:  xt this should really be called "ReportsTab" in views and it should call "reports" component to populate the table.
**             and probably to be very correct there should be a component that only fetches the user incidents and one to fetch the responder inc.
** 20250629:  xt fixed styles for B5 now. matched Report agency name title with Incident agecny name title
**            xt next to fix the style for the left side filter.
** 20250707:  xt added PropTypes import to fix runtime error
** 20260813:  xt fix report bug to paginate
** 20261003:  xt update to remove the 500 report limit on download
*/
import React, { useState, useEffect, useRef } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types'; // Added to fix runtime error
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { useAuth0 } from '@auth0/auth0-react';
import { useParams, useLocation } from 'react-router-dom';

// Services
import LocalizationService from "../../utils/LocalizationService";

// Utilities
import { getAgencyStatusMap } from "../../utils/ObjectFilters";
import { languageLabel } from "../../utils/Languages";

// Actions
import { requestStubs, selectAgencyId } from "../../actions/agencyStubs";
import { fetchAgency } from "../../actions/agency";
import { fetchReport } from "../../actions/report";
import { fetchAllReportCSV, clearIsfetching } from "../../actions/csvReports";

// Components
import AgencyList from "../../components/Agencies/AgencyList";
import Reports from "../../components/Reports/Reports";


const Report = ({
  agencyStubs,
  agency,
  report,
  isFetching,
  reportCSV,
  isFetchingcsv, // this is legacy code we use state now not props
  reports,
  languages,
  current_language,
  totalPages,
  en_count,
  es_count,
  count,
  inc_types,
  timezones,
  error,
  languageCode,
  profile,

}) => {
  const dispatch = useDispatch();
  const { getAccessTokenSilently } = useAuth0();
   const { id } = useParams(); // 👈 pulls the route param `:id` (replacement for match.params.id)
  const timeoutRef = useRef(null);

  const [state, setState] = useState({
    startDate: "",
    endDate: "",
    current_language: "en_US",
    checkboxvalue: [],
    checkboxStatusvalue: [],
    checkboxLanguagevalue: [],
    rowPerPage: 10,
    curPage: 1,
    totalPagesIN: 0,
    updatePageRow: 10,
    isFetching: false,
    csvReports: [],
    timezone: "",
    width: window.innerWidth,
    height: window.innerHeight,
  });

  /*New code added by GK 09-15-2023 to update the windows dim start*/
  const updateWindowDimensions = () => {
    setState((prev) => ({
      ...prev,
      width: window.innerWidth,
      height: window.innerHeight - 300,
    }));
  };
  /*New code added by GK 09-15-2023 end*/

  // componentWillMount and componentDidMount
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const token = await getAccessTokenSilently({
          authorizationParams: {
            audience: process.env.REACT_APP_AUTH0_AUDIENCE,
            scope: 'openid profile email',
          },
        });
        console.log('Reports.js - Access token fetched:', token);

        if (!agencyStubs.selectedAgencyId && agencyStubs.items.length === 0) {
          dispatch(requestStubs(token));
        } else if (agencyStubs.selectedAgencyId && !agency.details._id) {
          dispatch(fetchAgency(agencyStubs.selectedAgencyId, token));
        }

        prepareFetch(agencyStubs.selectedAgencyId, token);
      } catch (err) {
        console.error('Reports.js - Failed to fetch token:', err);
        dispatch(setError(null, 'Token Error', 'Failed to authenticate. Please log in again.'));
      }
    };

    fetchInitialData();

    /*New code added by GK 09-15-2023 start*/
    setState((prev) => ({
      ...prev,
      width: window.innerWidth,
      height: window.innerHeight - 300,
    }));
    window.addEventListener("resize", updateWindowDimensions);
    /*New code added by GK 09-15-2023 end*/

    return () => {
      window.removeEventListener("resize", updateWindowDimensions);
      clearTimeout(timeoutRef.current);
    };
  }, [dispatch, getAccessTokenSilently, agencyStubs.selectedAgencyId, agencyStubs.items, agency.details._id]);

  // componentWillReceiveProps
  useEffect(() => {
    if (reportCSV) {
      setState((prev) => ({
        ...prev,
        csvReports: reportCSV.items,
        isFetchingcsvv: isFetchingcsv,
      }));
    }

    if (!agencyStubs.selectedAgencyId) {
      const agencyId = id || null;
      if (agencyId) {
        dispatch(selectAgencyId(agencyId));
      } else if (agencyStubs.items.length === 1) {
        dispatch(selectAgencyId(agencyStubs.items[0]._id));
      }
    }

    if (report.lastUpdated) {
      if (reports !== report.reports) {
        clearTimeout(timeoutRef.current);
        setState((prev) => ({
          ...prev,
          isFetching: report.isFetching,
        }));
        if (!report.isFetching) {
          if (!state.current_language && report.current_language) {
            setState((prev) => ({
              ...prev,
              current_language: report.current_language,
              totalPagesIN: report.totalPages,
            }));
          }
        }
      }
    } else {
      if (!report.isFetching) {
        prepareFetch(agencyStubs.selectedAgencyId);
      }
    }
  }, [
    dispatch,
    id,
    agencyStubs.selectedAgencyId,
    agencyStubs.items,
    reportCSV,
    isFetchingcsv,
    report.lastUpdated,
    report.isFetching,
    report.current_language,
    report.totalPages,
    reports,
    report.reports,
    timezones,
  ]);

// added by chat 20250719 to go with handlestatuscheckbox
useEffect(() => {
  if (agencyStubs?.selectedAgencyId) {
    prepareFetch(agencyStubs.selectedAgencyId);
  }
}, [state.checkboxStatusvalue]);

// new from chatgAI.. we can combine later but keep for now
useEffect(() => {
  if (agencyStubs?.selectedAgencyId) {
    prepareFetch(agencyStubs.selectedAgencyId);
  }
}, [state.checkboxLanguagevalue]);
// these aer added to handl new ahandle checkbox code
useEffect(() => {
  if (agencyStubs?.selectedAgencyId) {
    prepareFetch(agencyStubs.selectedAgencyId);
  }
}, [state.checkboxvalue]);

// bug fix to pagination
  const prepareFetch = async (agencyId, token, pageOverride = null) => {
    let dates = moment(state.endDate, "MM/DD/YYYY hh:mm:ss A").format(
      "MM/DD/YYYY HH:mm:ss"
    );
    let formattedState = {
      start: state.startDate && moment(state.startDate).valueOf(),
      end:
        state.endDate &&
        moment(
          moment(dates)
            .add({
              hours: 23,
              minutes: 59,
              seconds: 59,
            })
            .format("MM/DD/YYYY HH:mm:ss")
        ).valueOf(),
      current_language: state.current_language,
      pageSize: state.rowPerPage,
      page: pageOverride ?? state.curPage,
      user_language: JSON.stringify(state.checkboxLanguagevalue),
      status_ids: JSON.stringify(state.checkboxStatusvalue),
      title: JSON.stringify(state.checkboxvalue),
    };
    const params = {};
    for (let queryParam of [
      "start",
      "end",
      "current_language",
      "pageSize",
      "page",
      "user_language",
      "status_ids",
      "title",
    ]) {
      if (formattedState[queryParam] !== undefined) {
        params[queryParam] = formattedState[queryParam];
      }
    }
    try {
      const tokenToUse = token || (await getAccessTokenSilently({
        authorizationParams: {
          audience: process.env.REACT_APP_AUTH0_AUDIENCE,
          scope: 'openid profile email',
        },
      }));
      console.log('Reports.js - Access token fetched for fetchReport:', tokenToUse);
      dispatch(fetchReport(agencyId, tokenToUse, params));
    } catch (err) {
      console.error('Reports.js - Failed to fetch token for fetchReport:', err);
      dispatch(setError(null, 'Token Error', 'Failed to authenticate. Please log in again.'));
    }
    console.log("at view reports after dispatch fetchReport line 291ish props =", { agencyStubs, report });
  };



  const handleTimezone = (data) => {
    setState((prev) => ({
      ...prev,
      timezone: data.value === "Select timezone" ? "" : data.value,
    }));
    console.log("view-Reports- timzone called", data.value);
  };

  const handleChange = (e) => {
    const tar = e.target.id;
    setState((prev) => ({
      ...prev,
      [tar]: e.target.value,
    }));
  };

  const handleStart = (e) => {
    setState((prev) => ({
      ...prev,
      startDate: e,
    }));
  };

  const handleEnd = (e) => {
    setState((prev) => ({
      ...prev,
      endDate: e,
    }));
  };

  const handleLanguageChange = (current_language_option) => {
    const current_language = current_language_option.value;
    setState((prev) => ({
      ...prev,
      current_language,
    }));
    clearTimeout(timeoutRef.current);
    prepareFetch(agencyStubs.selectedAgencyId);
  };

  /**
   * @author Sultan
   * 03-03-2023
   * Incident type checkbox filter handler. this is out of daet can remvoe
   */
  // const handleCheckBox = (e) => {
  //   const isChecked = e.target.checked;
  //   if (isChecked) {
  //     setState((prev) => ({
  //       ...prev,
  //       checkboxvalue: [...prev.checkboxvalue, e.target.value],
  //     }), () => prepareFetch(agencyStubs.selectedAgencyId));
  //   } else {
  //     const newCheckboxValue = [...state.checkboxvalue];
  //     const index = newCheckboxValue.indexOf(e.target.value);
  //     newCheckboxValue.splice(index, 1);
  //     setState((prev) => ({
  //       ...prev,
  //       checkboxvalue: newCheckboxValue,
  //     }), () => prepareFetch(agencyStubs.selectedAgencyId));
  //   }
  // };

// new from chatgAI 20250719 Refactor handleCheckBox to remove the callback from setState:
  const handleCheckBox = (e) => {
  const isChecked = e.target.checked;
  const value = e.target.value;

  setState((prev) => {
    const updatedValues = isChecked
      ? [...prev.checkboxvalue, value]
      : prev.checkboxvalue.filter((v) => v !== value);

    return {
      ...prev,
      checkboxvalue: updatedValues,
    };
  });
};

  /**
   * @author Sultan
   * 03-03-2023
   * Export Modal Open Handler.
   */
  const handleExportModalOpen = () => {
    setState((prev) => ({
      ...prev,
      isFetchingcsvv: "",
    }));
  };

  const handleExportModalClose = () => {
  console.log("handleExportModalClose called - closing modal");
  dispatch(clearIsfetching());
};

  /**
   * @author Sultan
   * 03-03-2023
   * Status checkbox filter handler. this was causing error in redux states
   */
  // const handleStatusCheckBox = (e) => {
  //   const isChecked = e.target.checked;
  //   if (isChecked) {
  //     setState((prev) => ({
  //       ...prev,
  //       checkboxStatusvalue: [...prev.checkboxStatusvalue, e.target.value],
  //     }), () => prepareFetch(agencyStubs.selectedAgencyId));
  //   } else {
  //     const newCheckboxStatusValue = [...state.checkboxStatusvalue];
  //     const index = newCheckboxStatusValue.indexOf(e.target.value);
  //     newCheckboxStatusValue.splice(index, 1);
  //     setState((prev) => ({
  //       ...prev,
  //       checkboxStatusvalue: newCheckboxStatusValue,
  //     }), () => prepareFetch(agencyStubs.selectedAgencyId));
  //   }
  // };

  // new one from chatg
const handleStatusCheckBox = (e) => {
  const isChecked = e.target.checked;
  const value = e.target.value;

  setState((prev) => {
    const updatedValues = isChecked
      ? [...prev.checkboxStatusvalue, value]
      : prev.checkboxStatusvalue.filter((v) => v !== value);

    return {
      ...prev,
      checkboxStatusvalue: updatedValues,
    };
  });
};


  /**
   * @author Sultan
   * 03-03-2023
   * User language checkbox filter handler. HTIS IS OUT OF DATE NOW CAN REMOBE
   */
  // const handleCheckBoxLanguage = (e) => {
  //   const isChecked = e.target.checked;
  //   if (isChecked) {
  //     setState((prev) => ({
  //       ...prev,
  //       checkboxLanguagevalue: [...prev.checkboxLanguagevalue, e.target.value],
  //     }), () => prepareFetch(agencyStubs.selectedAgencyId));
  //   } else {
  //     const newCheckboxLanguageValue = [...state.checkboxLanguagevalue];
  //     const index = newCheckboxLanguageValue.indexOf(e.target.value);
  //     newCheckboxLanguageValue.splice(index, 1);
  //     setState((prev) => ({
  //       ...prev,
  //       checkboxLanguagevalue: newCheckboxLanguageValue,
  //     }), () => prepareFetch(agencyStubs.selectedAgencyId));
  //   }
  // };

// THIS IS NEW FROM CHATG 20250719
const handleCheckBoxLanguage = (e) => {
  const isChecked = e.target.checked;
  const value = e.target.value;

  setState((prev) => {
    const updatedValues = isChecked
      ? [...prev.checkboxLanguagevalue, value]
      : prev.checkboxLanguagevalue.filter((v) => v !== value);

    return {
      ...prev,
      checkboxLanguagevalue: updatedValues,
    };
  });
};


  /**
   * @author Sultan
   * 03-03-2023
   * Update page row size function.
   */
  const handlePageRow = (e) => {
    setState((prev) => ({
      ...prev,
      rowPerPage: e,
      updatePageRow: e,
    }), () => prepareFetch(agencyStubs.selectedAgencyId));
  };

  /**
   * @author Sultan
   * 03-03-2023
   * Update page size function.
   */
  const handlePageSize = (e) => {
    if (e.target.value) {
      setState((prev) => ({
        ...prev,
        curPage: e.target.value,
      }), () => prepareFetch(agencyStubs.selectedAgencyId));
    }
  };

  /**
   * @author XT
   * 08-13-2026
   * Pagination next handler bug fix to go to next page.
   */
  const handleNext = () => {
  if (state.curPage !== totalPages && !state.isFetching) {
    const nextPage = state.curPage + 1;

    setState((prev) => ({
      ...prev,
      curPage: nextPage,
    }));

    prepareFetch(
      agencyStubs.selectedAgencyId,
      null,
      nextPage
    );
  }
};

  /**
   * @author XT
   * 08-13-2026
   * Pagination previous handler bug fix to go to previous page.
   */
  const handlePrev = () => {
  if (state.curPage > 1 && !state.isFetching) {
    const prevPage = state.curPage - 1;

    setState((prev) => ({
      ...prev,
      curPage: prevPage,
    }));

    prepareFetch(
      agencyStubs.selectedAgencyId,
      null,
      prevPage
    );
  }
};

   /**
   * @author xt
   * 10-03-2026
   *
   * REPORTS TAB - EXPORT ALL MATCHING REPORTS
   *
   * Exports every report matching the currently selected Reports filters.
   *
   * The former Reports export was limited to 500 records. That limit has
   * been removed from the Reports tab. fetchAllReportCSV() retrieves large
   * result sets in 500-record batches using the backend's existing
   * pagination support, then combines those batches for the CSV export.
   *
   * This does NOT change normal Reports pagination. The Reports table
   * continues to request only the currently displayed page of records.
   */
  const handleCsv = async () => {
    let dates = moment(state.endDate, "MM/DD/YYYY hh:mm:ss A").format(
      "MM/DD/YYYY HH:mm:ss"
    );

    let formattedState = {
      start: state.startDate && moment(state.startDate).valueOf(),
      end:
        state.endDate &&
        moment(
          moment(dates)
            .add({
              hours: 23,
              minutes: 59,
              seconds: 59,
            })
            .format("MM/DD/YYYY HH:mm:ss")
        ).valueOf(),
      current_language: state.current_language,
      user_language: JSON.stringify(state.checkboxLanguagevalue),
      status_ids: JSON.stringify(state.checkboxStatusvalue),
      title: JSON.stringify(state.checkboxvalue),
    };

    const params = {};

    for (let queryParam of [
      "start",
      "end",
      "current_language",
      "user_language",
      "status_ids",
      "title",
    ]) {
      if (formattedState[queryParam] !== undefined) {
        params[queryParam] = formattedState[queryParam];
      }
    }

    try {
      const token = await getAccessTokenSilently({
        authorizationParams: {
          audience: process.env.REACT_APP_AUTH0_AUDIENCE,
          scope: "openid profile email",
        },
      });

      console.log(
        "Reports.js - Access token fetched for batched Reports export"
      );

      dispatch(
        fetchAllReportCSV(
          agencyStubs.selectedAgencyId,
          token,
          params
        )
      );
    } catch (err) {
      console.error(
        "Reports.js - Failed to fetch token for Reports export:",
        err
      );

      dispatch(
        setError(
          null,
          "Token Error",
          "Failed to authenticate. Please log in again."
        )
      );
    }
  };


  /**
   * @author Sultan
   * 03-03-2023
   * clear all filter function
   */
  const handleclearAll = () => {
    if (
      state.checkboxvalue.length > 0 ||
      state.checkboxStatusvalue.length > 0 ||
      state.checkboxLanguagevalue.length > 0 ||
      state.startDate ||
      state.endDate
    ) {
      setState((prev) => ({
        ...prev,
        checkboxvalue: [],
        checkboxStatusvalue: [],
        checkboxLanguagevalue: [],
        startDate: "",
        endDate: "",
      }), () => prepareFetch(agencyStubs.selectedAgencyId));
    }
  };

  // if (!agencyStubs.selectedAgencyId && agencyStubs.items.length > 0) {
  //   return (
  //     <AgencyList
  //       pathRef="/dashboard"
  //       agencies={agencyStubs.items}
  //       languageCode={languageCode}
  //     />
  //   );
  // }

  if (!agencyStubs.selectedAgencyId) {
  console.error("Missing selected agency ID — app should have set this at login.");
  return <p className="text-danger">Error: No agency selected. Please log in again.</p>;
}
  return (
    <div className="report-container">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <div style={{ width: "10%" }}>
          {/* <div style={{ width: "200px", paddingLeft: "1rem" }}>
            Language:
            <Select
              name="form-field-name"
              clearable={false}
              value={current_language}
              onChange={handleLanguageChange}
              options={["en_US", "es_US"].map((language) => ({
                value: language,
                label: languageLabel(language),
              }))}
            />
          </div> */}
        </div>
        <div style={{ width: "90%" }}>
       <h2 className="fs-4 text-center my-3">
            {agency.details.name ? agency.details.name[languageCode] : null}
          </h2>
        </div>
      </div>

      <div className="table-container">
        <Reports
          dispatch={dispatch}
          reports={reports}
          reportCSV={reportCSV.items}
          agency={agency}
          languageCode={languageCode}
          profile={profile}
          checkboxvalue={state.checkboxvalue}
          checkboxStatusvalue={state.checkboxStatusvalue}
          checkboxLanguagevalue={state.checkboxLanguagevalue}
          handleCheckBox={handleCheckBox}
          handleStatusCheckBox={handleStatusCheckBox}
          startDate={state.startDate}
          endDate={state.endDate}
          handleStart={handleStart}
          handleEnd={handleEnd}
          prepareFetch={() => prepareFetch(agencyStubs.selectedAgencyId)}
          page={state.curPage}
          handlePageRow={handlePageRow}
          totalPage={totalPages}
          updatePageRow={state.updatePageRow}
          handlePageSize={handlePageSize}
          handleNext={handleNext}
          handlePrev={handlePrev}
          handleCsv={handleCsv}
          handleclearAll={handleclearAll}
          handleCheckBoxLanguage={handleCheckBoxLanguage}
          isFetchingcsv={isFetchingcsv}
          isFetching={isFetching}
          en_count={en_count}
          es_count={es_count}
          count={count}
          inc_types={inc_types}
          timezones={timezones}
          timezone={state.timezone}
          handleExportModalClose={handleExportModalClose}
          handleTimezone={handleTimezone}
          /*New code added by GK 09-15-2023 to create scrollbars on table start*/
          height={state.height}
          width={state.width}
          /*New code added by GK 09-15-2023 end*/
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    agencyStubs: state.agencyStubs || { items: [], selectedAgencyId: null },
    agency: state.agency || { details: {} },
    report: state.report || { reports: [], isFetching: false, current_language: "en_US", totalPages: null },
    isFetching: state.report.isFetching || false,
    reportCSV: state.reportCSV || { items: [] },
    isFetchingcsv: state.reportCSV.isFetchingcsv || "",
    reports: state.report.reports || [],
    languages: state.report.languages || [],
    current_language: state.report.current_language || "en_US",
    totalPages: state.report.totalPages || null,
    en_count: state.report.en_count || 0,
    es_count: state.report.es_count || 0,
    count: state.report.count || 0,
    inc_types: state.report.inc_types || [],
    timezones: state.report.timezones || [],
    error: state.error || null,
    languageCode: LocalizationService.getCurrentLanguage(),
    profile: state.profile || {},
  };
};

Report.propTypes = {
  agencyStubs: PropTypes.shape({
    items: PropTypes.array,
    selectedAgencyId: PropTypes.string,
  }).isRequired,
  agency: PropTypes.shape({
    details: PropTypes.object,
  }).isRequired,
  report: PropTypes.shape({
    reports: PropTypes.array,
    isFetching: PropTypes.bool,
    current_language: PropTypes.string,
    totalPages: PropTypes.number,
    languages: PropTypes.array,
    en_count: PropTypes.number,
    es_count: PropTypes.number,
    count: PropTypes.number,
    inc_types: PropTypes.array,
    timezones: PropTypes.array,
    lastUpdated: PropTypes.any,
  }).isRequired,
  isFetching: PropTypes.bool.isRequired,
  reportCSV: PropTypes.shape({
    items: PropTypes.array,
  }).isRequired,
   isFetchingcsv: PropTypes.string.isRequired,
  reports: PropTypes.array.isRequired,
  languages: PropTypes.array.isRequired,
  current_language: PropTypes.string.isRequired,
  totalPages: PropTypes.number,
  en_count: PropTypes.number.isRequired,
  es_count: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  inc_types: PropTypes.array.isRequired,
  timezones: PropTypes.array.isRequired,
  error: PropTypes.object,
  languageCode: PropTypes.string.isRequired,
  profile: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(Report);